// extracted by mini-css-extract-plugin
export default {"mainGreen":"#5EDE99","mainWhite":"#fff","textGreen":"#379457","categoryBox":"my_category_categoryBox__Tl44A","xBtn":"my_category_xBtn__moYnk"};